import React from 'react'
import MorningIcon from '../../../../../Assets/Images/icons/newIcons/morningIcon'
import LunchIcon from '../../../../../Assets/Images/icons/newIcons/lunchIcon'
import AfternoonIcon from '../../../../../Assets/Images/icons/newIcons/afternoonIcon'

export const headers = [
  {
    label: 'Dates',
    xs: 4,
    align: 'flex-start',
    key: 'date',
  },
  {
    label: 'Morning',
    xs: 2,
    icon: <MorningIcon />,
    key: 'morningMissions',
  },
  {
    label: 'Lunch',
    xs: 2,
    icon: <LunchIcon />,
    key: 'lunchMissions',
  },
  {
    label: 'Afternoon',
    xs: 2,
    icon: <AfternoonIcon />,
    key: 'afternoonMissions',
  },
  {
    label: null,
    xs: 1,
    key: 'deleteButton',
  },
]
